import React, { Component } from 'react';
import { Row, Col, Button, Table, Card, Breadcrumb, Translate, Modal, Form, FormField, Input, FileButton, Icon, Image, Gallery, MediaPlayer } from '$common';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import { convertLocation } from '$lib/normalize';
import uploadFile from '$lib/upload-file';
import AnswerList from './answer-list';
import CSSModules from 'react-css-modules';
import style from './index.scss';

const Map = withScriptjs(withGoogleMap(props => {
  const { submission } = props;
  return <GoogleMap
    defaultZoom={14}
    defaultCenter={convertLocation(submission.location)}
    defaultOptions={{ scrollwheel: false }}
  >
    {submission.other_submissions ? (submission.other_submissions.map((submission, index) => (
      <Marker
        icon={require(`$shared/images/markers/withdrawn.png`)}
        position={convertLocation(submission.location)}
        onClick={() => window.open(`/project/${project.id}/submissions/${submission.id}`)}
        zIndex={index}
        key={index}
      />          
    ))) : null}
    <Marker
      icon={require(`$shared/images/markers/accepted.png`)}
      position={convertLocation(submission.location)}
      zIndex={999}
    />
  </GoogleMap>;
}));

@CSSModules(style)
export default class Show extends Component {
  state = {
    isAppealModalOpen: false,
    isScorable: this.props.submission.task.task_form.is_scorable,
    appealMedia: {
      images: [],
      // videos: [],
      // voice_records: []
    }
  };

  exemptedQuestions = submission =>  
    submission.exempted_questions.map(q => 
      <div key={q.id}>
        <div>
          {q.position}{') '}{q.label}{' => Max '}{q.max_answer_points} Points
        </div>
        <br></br>
      </div>
    )

  get submissionDetailColumns() {
    const { submission } = this.props;

    let columns = [
      { label: `${Translate.get('received_at')}`, width: '1', key: 'submitted_at', type: 'date' }
    ];

    if (submission.task.address) {
      columns = [
        { label: `${Translate.get('address')}`, width: '4/8', content: item => item.task.address },
        { label: `${Translate.get('received_at')}`, width: '4/8', key: 'submitted_at', type: 'date' }
      ]
    }

    if (submission.total_answer_points) {
      if (submission.task.address) {
        columns = [
          { label: `${Translate.get('total_answer_points')}`, width: '1/8', content: item => item.total_answer_points },
          { label: `${Translate.get('address')}`, width: '4/8', content: item => item.task.address },
          { label: `${Translate.get('received_at')}`, width: '3/8', key: 'submitted_at', type: 'date' }
        ]
      }
      else {
        columns = [
          { label: `${Translate.get('total_answer_points')}`, width: '4/8', content: item => item.total_answer_points },
          { label: `${Translate.get('received_at')}`, width: '4/8', key: 'submitted_at', type: 'date' }
        ]
      }

      if(submission.exempted_questions && submission.exempted_questions.length > 0) {
        if (submission.task.address) {
          columns = [
            { label: `${Translate.get('total_answer_points')}`, width: '1/8', content: item => item.total_answer_points },
            { label: `${Translate.get('exempted_questions')}`, width: '3/8', content: item => this.exemptedQuestions(item) },
            { label: `${Translate.get('address')}`, width: '3/8', content: item => item.task.address },
            { label: `${Translate.get('received_at')}`, width: '2/8', key: 'submitted_at', type: 'date' }
          ]
        }
        else {
          columns = [
            { label: `${Translate.get('total_answer_points')}`, width: '1/8', content: item => item.total_answer_points },
            { label: `${Translate.get('exempted_questions')}`, width: '5/8', content: item => this.exemptedQuestions(item) },
            { label: `${Translate.get('received_at')}`, width: '2/8', key: 'submitted_at', type: 'date' }
          ]
        }
      }
    }

    return columns;
  }

  async sendAppeal(values) {
    const { appealMedia } = this.state;

    const appealMediaURLs = [];

    const appealMediaKeys = Object.keys(appealMedia);
    for(const mediaType of appealMediaKeys) {
      for(const media of appealMedia[mediaType]) {
        if(media._destroy === undefined) {
          const url = await uploadFile('appeal_media', media);
          appealMediaURLs.push(`https://celebi${process.env.NODE_ENV === 'production' ? '' : '-dev'}.s3.eu-central-1.amazonaws.com/${url}`);
        }
      }
    }

    this.props.sendAppeal({...values, appeal_media_urls: appealMediaURLs});

    this.setState({
      isAppealModalOpen: false,
      isScorable: this.props.submission.task.task_form.is_scorable,
      appealMedia: {
        images: [],
        // videos: [],
        // voice_records: []
      }
    });
  }

  componentDidMount() {
    window.dispatchEvent(new Event('resize'));
  }
  

  addMediaToAppeal(file) {
    const { appealMedia } = this.state;

    if (file) {
      const fileType = file.type;
      const imagesArr = appealMedia.images;
      // const videosArr = appealMedia.videos;
      // const voice_recordsArr = appealMedia.voice_records;

      if (fileType.indexOf('image') !== -1) {
        imagesArr.push(file);
      }
      /* else if(fileType.indexOf('audio') !== -1) {
        voice_recordsArr.push(file);
      }
      else if(fileType.indexOf('video') !== -1) {
        videosArr.push(file);
      } */

      this.setState({
        appealMedia: {
          images: imagesArr,
          // videos: voice_recordsArr,
          // voice_records: videosArr
        }
      });
    }
  }
/* 
  openLightbox(media_type, media_index) {
    const currentMedia = URL.createObjectURL(this.state.appealMedia[media_type][media_index]);
    this.setState({
      isAppealModalOpen: false,
      lightboxIsOpen: true,
      galleryMedia: [{ src: currentMedia }],
      galleryCustomMedia: media_type !== 'images' ?
        <div style={{ width: '500px' }}>
          <MediaPlayer
            url={currentMedia}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}
          />
        </div>
        : null
    });
  }
   */
  render() {
    const { submission, project, agent } = this.props;
    const { isAppealModalOpen } = this.state;

    const isProjectAvailable = project.status === 'available';
    const isFieldCategory = project.project_categories && project.project_categories.find(c => c.id === 35);

    // window.Intercom('trackEvent', 'OPENED_SUBMISSION', { project_id: project.id });

    return (
      <div styleName="root">
        <Modal
          size="small"
          title={Translate.get('appeal')}
          isOpen={isAppealModalOpen}
          onCloseRequest={() => this.setState({
            isAppealModalOpen: false,
            appealMedia: {
              images: [],
              // videos: [],
              // voice_records: []
            }
          })}
        >
          <Form onSubmit={values => this.sendAppeal(values)}>
            <FormField label={Translate.get('appeal_text')} name="appeal_text">
              <Input
                rows={4}
                placeholder={Translate.get('appeal_text_placeholder')}
              />
            </FormField>
            <Row style={{ marginBottom: 10 }}>
              <span styleName="media-upload-label">{Translate.get('image')}</span>
              <FileButton
                type="weak"
                onChange={::this.addMediaToAppeal}
                onClick={event => {event.target.value = null}}
                // accept="image/*,video/*,audio/*"
                accept="image/*"
                >
                  {Translate.get('image_upload')}
                </FileButton>
            </Row>
            <Row>
              <div style={{ marginLeft: 10 }}>
                {
                  Object.keys(this.state.appealMedia).map( media_type => (
                    this.state.appealMedia[media_type].map( (media, index) => (media._destroy === undefined ) ? (
                      <div styleName="media-wrapper">
                          <div styleName="media" /* style={media_type === 'voice_records' || media_type === 'videos' ? { width: '110px' } : null} onClick={() => this.openLightbox(media_type, index)}*/>
                            <a styleName="delete-btn" onClick={e => {
                              e.stopPropagation(); 
                              let media = this.state.appealMedia;
                              media[media_type][index]._destroy = true;
                              this.setState({
                                appealMedia: media
                              });
                            }}>
                              <Icon name="times"/>
                            </a>
                            {
                              media_type === 'images' ?
                                <Image
                                  source={typeof media.type !== "undefined" ? URL.createObjectURL(media) : ''}
                                  width="70"
                                  square
                                />
                              : null
                            }
                            {/* {
                              media_type === 'voice_records' || media_type === 'videos' ?
                                <span styleName="play-media">
                                  <Icon name="play" />
                                </span>
                              : null
                            } */}
                          </div>
                      </div>
                    ) : '')
                  ))
                }
              </div>
            </Row>
            <Button type="success" block submit>{Translate.get('send_appeal')}</Button>
          </Form>
        </Modal>

        <div id="not-printable">
          <Row>
            <Col md="4/6">
              <Breadcrumb
                routes={[
                  { label: Translate.get('home'), to: `/` },
                  { label: project.name, to: `/project/${project.id}` },
                  { label: `${Translate.get('submissions')}`, to: `/project/${project.id}/submissions` },
                  { label: `${Translate.get('submissions_details')}` }
                ]}
              />
            </Col>
            <Col md="1/6" className="appeal-button-col">
              {
                (agent.permissions && (agent.permissions.includes('all') || agent.permissions.includes('appeal')) && isProjectAvailable) ? 
                  <Button
                    block
                    type="ghost"
                    size="small"
                    className="appeal-button"
                    onClick={() => this.setState({
                      isAppealModalOpen: true,
                      appealMedia: {
                        images: [],
                        // videos: [],
                        // voice_records: []
                      }
                    })}>
                      {Translate.get('appeal')}
                  </Button> 
                  : null
              }
            </Col>
            <Col md="1/6" className="print-button-col">
              <Button type="ghost" block size="small" className="print-button" onClick={() => window.print()}>Print Page</Button>
            </Col>
          </Row>
        </div>
        
        <Table
          columns={[
            { label: 'TASK ID', width: '1/8', content: item => item.task.id },
            { label: `${Translate.get('task_title')}`, width: '4/8', content: item => item.task.title },
            { label: `${isFieldCategory ? Translate.get('visit_location') : Translate.get('task_location')}`, width: '3/8', content: item => (item.task.area ? item.task.area.name : item.task.location) }
          ]}
          data={(submission && submission.task && [submission]) || []}
        />

        <br />

        <Table
          columns={this.submissionDetailColumns}
          data={(submission && [submission]) || []}
        />

        <br/>

        {
          (agent.permissions && (agent.permissions.includes('all') || agent.permissions.includes('submission_location_details'))) ? 
            <Card header={Translate.get('submission_location_details')}>
              {submission ? (
                <Map
                  submission={submission}
                  googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env[0].GOOGLE_KEY}&v=3.exp&libraries=drawing,visualization`}
                  loadingElement={
                    <div style={{ height: `200px` }} />
                  }
                  containerElement={
                    <div style={{ height: `200px` }} />
                  }
                  mapElement={
                    <div style={{ height: `200px` }} />
                  }
                />
              ) : null}
            </Card> : null
        }
        <br/>

        <Card header={Translate.get('responses')}>
        <Row>
            {
            !this.props.inLightbox ?
            <Col md="2/30" styleName="table-header-number" >
            <div>
                  {Translate.get('question')}
                </div>
            </Col>
            : ''
            }
            <Col md={this.props.inLightbox ? "6/30" : "6/30"} styleName="table-header-cell" style={{paddingLeft: "30px"}}>
            <div style={{paddingLeft: "10px"}}>
                 {Translate.get('question_title')}
              </div>
              </Col>
              <Col md={this.props.inLightbox ? "6/30" : "6/30"} styleName="table-header-cell" >
            <div>
                {Translate.get('answers')}
              </div>
              </Col>
           	{ this.state.isScorable === true ? (
              <Col md={ this.props.inLightbox ? "6/30" : "6/30"} styleName="table-header-cell" style={{textAlign: "center"}}>
            <div>
                {Translate.get('answers_score')}
              </div>
              </Col>
             ) : null
            }
           	{ this.state.isScorable === true ? (
              <Col md={this.props.inLightbox ? "5/30" : "5/30"} styleName="table-header-cell" style={{textAlign: "center"}}>
            <div>
                {Translate.get('total_answers_points')}
              </div>
              </Col>
                ) : null
            }
           	{ this.state.isScorable === true ? (
              <Col md={this.props.inLightbox ? "5/30" : "5/30"} styleName="table-header-cell" style={{textAlign: "center"}}>
            <div>
                {Translate.get('max_score')}
              </div>
              </Col>
                ) : null
            }
          <div styleName='center_bottom_line'> </div>
          </Row>
          {submission ? (
            <AnswerList
              exempted_questions={submission.exempted_questions}
              is_scorable={submission.task.task_form.is_scorable}
              questions={submission.task.task_form.questions}
              answers={submission.answers}
            />
          ) : null}
        </Card>

        <br/>
{/* 
        { this.state.lightboxIsOpen ? 
        <Gallery
          images={this.state.galleryMedia}
          lightboxIsOpen={this.state.lightboxIsOpen}
          customMedia={this.state.galleryCustomMedia}
          onClose={() => this.setState({ lightboxIsOpen: false, isAppealModalOpen: true })}
        /> : null} */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/submissions/show/index.js